import { createSlice } from "@reduxjs/toolkit";

const partRequest = createSlice({
    name: "partRequest",
    initialState: {
        partRequestCount: null,
        isLoaded: false,
        allActivePartRequests: [],
        activePartRequestsLoaded: false
    },
    reducers: {
        getPartRequestCount(state, _action) {
            return { ...state, isLoaded: false }
        },
        setPartRequestCount(state, action) {
            const count = action.payload;
            return { ...state, partRequestCount: count, isLoaded: true };
        },
        getAllActiveRequests(state, _action) {
            return { ...state, activePartRequestsLoaded: false }
        },
        setAllActiveRequests(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                allActivePartRequests: requestData[1],
                count: requestData[0],
                activePartRequestsLoaded: true,
            }
        },
        createRequest(state, _action) {
            return { ...state, isLoaded: false }
        }
    },
});

export const {
    getPartRequestCount,
    setPartRequestCount,
    getAllActiveRequests,
    setAllActiveRequests,
    createRequest,
} = partRequest.actions;

export default partRequest.reducer;
